import Image from "next/legacy/image";

import { formatNumber } from "koljobs-helpers";

type IGFollowerNumberItemProps = {
  instagramFollowerCount?: number;
};

export const IGFollowerNumberItem = ({
  instagramFollowerCount,
}: IGFollowerNumberItemProps) => {
  if (instagramFollowerCount <= 0) return null;

  return (
    <div className="absolute bottom-2 right-2 flex justify-end">
      <div className="z-10 flex items-center space-x-1 rounded-full bg-white px-2 py-1 text-sm text-gray-700">
        <Image
          layout="fixed"
          objectFit="cover"
          height={16}
          width={16}
          src="/images/ig.png"
          alt="ig"
        />

        <span className="font-medium">
          {formatNumber(instagramFollowerCount ?? 0)}
        </span>
        <span className="font-light">followers</span>
      </div>
    </div>
  );
};
